export const isAppleMobileDevice = () =>
  typeof navigator !== "undefined" &&
  (/iPhone|iPad|iPod/i.test(navigator.userAgent || "") ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));

export const livePhotoUploadAccept = (baseAccept) =>
  isAppleMobileDevice() ? `${baseAccept},.livp,.zip` : baseAccept;